import React from 'react';
import ErrorComponent from './ErrorComponent';

const PageNotFound = props => {
  return <ErrorComponent props={props} errorType="404"></ErrorComponent>;
};

export default PageNotFound;
